@if (!isDataLoading) {
<div class="app__template--component--spacing">
  <div *ngIf="filteredFormRolePlayers.length">
    <h3 class="app__template--linked--header">Role Players</h3>
    @for (category of filteredFormRolePlayers; track category; let last = $last; let i = $index) {
    <ng-container
      *ngTemplateOutlet="
        rolePlayerCard;
        context: {
          category: category,
          last: last,
          index: i,
          isParentTrustAndSubTrust: false,
          refName: 'rolePlayersComponent'
        }
      "
    ></ng-container>
    }
  </div>
  <div *ngIf="formParentTrustAndSubTrust.length">
    @for (trustCategory of formParentTrustAndSubTrust; track trustCategory; let last = $last; let i = $index) {
    <ng-container
      *ngTemplateOutlet="
        rolePlayerCard;
        context: {
          category: trustCategory,
          last: last,
          index: i,
          isParentTrustAndSubTrust: true,
          refName: 'parentAndSubTrustRolePlayerComponent'
        }
      "
    ></ng-container>
    }
  </div>
</div>
}

<ng-template
  #rolePlayerCard
  let-category="category"
  let-last="last"
  let-index="index"
  let-isParentTrustAndSubTrust="isParentTrustAndSubTrust"
  let-refName="refName"
>
  <div [class]="!last ? 'mb-4' : ''">
    <role-players-card-view
      #dynamicRolePlayerRef
      [attr.data-category]="category"
      [attr.data-ref-type]="refName"
      [id]="refName + '_' + index"
      [mode]="mode"
      [data]="data"
      [origin]="origin"
      [formName]="formName"
      [category]="category"
      [formsList]="formsList"
      [templateId]="templateId"
      [currentuserId]="currentuserId"
      [currentFormId]="currentFormId"
      [aiIsProcessing]="aiIsProcessing"
      [hideManageButton]="hideManageButton"
      [rolePlayersJsonData]="rolePlayersJsonData"
      [parentTrustAndSubTrust]="isParentTrustAndSubTrust"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      [availableAISuggestions]="!isParentTrustAndSubTrust ? rolePlayersSuggestionsByCategory[category] || [] : []"
      (rolePlayerSelectionChange)="onRolePlayerSelectionChange($event)"
      (aiSuggestionSelectionChange)="onAISuggestionSelectionChange($event)"
    >
    </role-players-card-view>
  </div>
</ng-template>
